module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Bold.498c9488.woff";